import { ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";

export function MultiFilter({ filter, options, selected = [], onChange }) {
  if (!options.length) return null;
  const toggle = (v) => onChange(selected.includes(v) ? selected.filter((x) => x !== v) : [...selected, v]);
  const active = selected.length > 0;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          data-testid={`filter-${filter.key}`}
          className={`shrink-0 inline-flex items-center gap-1.5 h-11 px-4 rounded-xl text-sm font-semibold border transition-colors ${active ? "bg-navy text-white border-navy" : "bg-white border-border text-navy hover:border-navy/40"}`}
        >
          {filter.label}
          {active && <span className="ml-0.5 h-5 min-w-5 px-1 rounded-full bg-orange text-white text-[11px] flex items-center justify-center">{selected.length}</span>}
          <ChevronDown className="h-3.5 w-3.5 opacity-70" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-64 p-2 max-h-80 overflow-y-auto" data-testid={`filter-${filter.key}-panel`}>
        {options.map(([value, count]) => (
          <label key={value} className="flex items-center gap-2.5 px-2 py-2 rounded-lg hover:bg-secondary cursor-pointer text-sm text-navy">
            <Checkbox
              data-testid={`filter-${filter.key}-option-${value}`}
              checked={selected.includes(value)}
              onCheckedChange={() => toggle(value)}
            />
            <span className="flex-1 truncate">{value}</span>
            <span className="text-xs text-muted-foreground">{count}</span>
          </label>
        ))}
        {active && (
          <button onClick={() => onChange([])} className="w-full mt-1 text-xs font-semibold text-orange py-1.5 hover:underline" data-testid={`filter-${filter.key}-clear`}>
            Clear {filter.label.toLowerCase()}
          </button>
        )}
      </PopoverContent>
    </Popover>
  );
}
